export default "__VITE_ASSET__Cfnnx1ZT__"